import type { StrictLocaleObject } from '#layers/i18n/shared/locales'
import type { Composer } from 'vue-i18n'

export default defineNuxtPlugin({
  name: 'fetch',
  dependsOn: ['i18n:plugin'],
  enforce: 'pre',
  setup(nuxtApp) {
    const getAppConfig = () => useRuntimeConfig().app
    const baseURL = () => getAppConfig().baseURL

    const getHeaders = () => {
      // Compute headers dynamically to always get current locale
      const i18n = nuxtApp.$i18n as Composer | undefined
      const currentLocale = i18n?.locale?.value
      const locales = i18n?.locales?.value as unknown as StrictLocaleObject[] | undefined
      const currentLocaleObject = currentLocale && locales
        ? locales.find(l => l.code === currentLocale) as StrictLocaleObject | undefined
        : null

      return {
        'X-Locale-Code-Cookie': currentLocale ?? 'en',
        'X-Locale-Code': currentLocaleObject?.code ?? 'en',
        'X-Language-Code': (currentLocaleObject?.language ?? 'en').split('-')[0],
        'X-Currency-Code': currentLocaleObject?.currency ?? 'USD',
        'X-Fetch-Client': 'Nuxt',
      }
    }

    const fetch = $fetch.create({
      baseURL: baseURL(),
      headers: getHeaders(),
    })

    // if (import.meta.client) {
    globalThis.$fetch = fetch
    // }
  },
})
